import { Box, Stack } from '@mui/material';
import { RegisterCustomerFields } from './RegisterCustomerFields';
import { TrialSummaryCard } from './TrialSummaryCard';

/**
 * Step 2 — company + primary contact. Every input maps 1:1 to a field accepted by
 * PublicTrialRegistrationRequest.
 *
 * Deferred (accepted by the backend request, intentionally not exposed yet):
 * address_line2, contact_phone/phone/country legacy aliases, seats.
 * They stay out of the payload until Figma defines the UI for them.
 */
export function RegisterStepCompany({
  form,
  stepErrors,
  optionsWarning,
  registerOptions,
  selectedCountry,
  phonePrefixCountries,
  phonePrefixCountryCode,
  phoneValidationError,
  consentAccepted,
  onFieldChange,
  onCompanyNameChange,
  onCustomerTypeChange,
  onCountryChange,
  onPhonePrefixChange,
  onPhoneNumberChange,
  onConsentChange,
  preview,
  previewLoading,
  previewError,
  selectedModules,
  billingInterval,
  usersCount,
  smsNotificationsEnabled,
  startMode,
  findCountryByCode,
}) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      spacing={2}
      alignItems="flex-start"
      data-testid="register-step-company"
    >
      <RegisterCustomerFields
        form={form}
        stepErrors={stepErrors}
        optionsWarning={optionsWarning}
        registerOptions={registerOptions}
        selectedCountry={selectedCountry}
        phonePrefixCountries={phonePrefixCountries}
        phonePrefixCountryCode={phonePrefixCountryCode}
        phoneValidationError={phoneValidationError}
        consentAccepted={consentAccepted}
        onFieldChange={onFieldChange}
        onCompanyNameChange={onCompanyNameChange}
        onCustomerTypeChange={onCustomerTypeChange}
        onCountryChange={onCountryChange}
        onPhonePrefixChange={onPhonePrefixChange}
        onPhoneNumberChange={onPhoneNumberChange}
        onConsentChange={onConsentChange}
        findCountryByCode={findCountryByCode}
      />

      <Box sx={{ width: { xs: '100%', md: 300 }, flexShrink: 0 }}>
        <TrialSummaryCard
          preview={preview}
          loading={previewLoading}
          error={previewError}
          selectedModules={selectedModules}
          billingInterval={billingInterval}
          usersCount={usersCount}
          smsNotificationsEnabled={smsNotificationsEnabled}
          startMode={startMode}
        />
      </Box>
    </Stack>
  );
}

export default RegisterStepCompany;
